import { render, staticRenderFns } from "./galleryAlbumEdit.vue?vue&type=template&id=6b0c56cc&scoped=true&"
import script from "./galleryAlbumEdit.vue?vue&type=script&lang=js&"
export * from "./galleryAlbumEdit.vue?vue&type=script&lang=js&"
import style0 from "./galleryAlbumEdit.vue?vue&type=style&index=0&id=6b0c56cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c56cc",
  null
  
)

export default component.exports